// eslint-disable-next-line import/no-anonymous-default-export
export default {
  meEndpoint: '/admin/me',
  loginEndpoint: '/jwt/login',
  registerEndpoint: '/jwt/register',
  storageTokenKeyName: 'token'
}
